import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step5 } from '../../../../../shared/models/component-messages/mapaAT/step5';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { Attribution } from '../../models/Attribution';
import { LotMarche } from '../../models/LotMarche';
import { CTRL_322 } from '../../../../validators/322/ctrl322';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-step5',
  templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {

  @Input() attribution: Attribution;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
  public rg4 = CTRL_322.id + '_1';

  public step5 = new Step5();

  constructor(private formExtractorService: FormExtractorService, public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService: AvisDataTransferService) { }

  ngOnInit(): void {
    if (!this.attribution.lotMarche) {
      this.attribution.lotMarche = []; 
    }
  }

  getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_Attribution';
  }

  addlotMarche() {
		this.attribution.lotMarche.push(new LotMarche());
  }

  removelotMarche(i: number) {
		this.attribution.lotMarche.splice(i, 1);
	}

  public getType() {
    return this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.resultatAttribution;
  }

  public isAttribue(): boolean {
    return this.getType() !== RadioCheckBoxEnum.sansSuite
      && this.getType() !== RadioCheckBoxEnum.infructueux;
  }

  public isAttributionParLots(): boolean {
    if (this.getType() === RadioCheckBoxEnum.attribueLots
    || this.getType() === RadioCheckBoxEnum.lotsInfructueux) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ }));
      let lotMarcheIter = 1;
    }
    return this.getType() === RadioCheckBoxEnum.attribueLots
      || this.getType() === RadioCheckBoxEnum.lotsInfructueux;
  }

  getStepId() {
	  return this.uid + '_';
	}
}
